import $ from 'jquery';

export default {
    init() {
        $('.changeQuantityForm').on('change', function(e) {
            
            e.preventDefault();
            const form = $(this);
            const qtyInput = form.find('input[name="quantity"]');
            const inputVal = parseInt(qtyInput.val(), 10);
            
            form.submit();
        })
        $('.changeQuantityForm').on('click', '[data-qty]:not(a)', function(e) {
            e.preventDefault();
            const way = $(this).data('qty');
            
            if (!way) return;

            const form = $(this).parents('form');

            const quantityInput = form.find('input[name="quantity"]');
            let quantity = parseInt(quantityInput.val(), 10);
    
            const quantityStep = +quantityInput.attr('step') || 100;
            const quantityMin = +quantityInput.attr('min') || 100;
            const quantityMax = +quantityInput.attr('max') || 5000;

            if (way === 'minus') {
                if ((quantity - quantityStep) < quantityMin) {
                    quantityInput.val(quantityMin);
                } else {
                    quantityInput.val(quantity - quantityStep);
                }
                
            } else if (way === 'plus') {
                if ((quantity + quantityStep) > quantityMax) {
                    quantityInput.val(quantityMax);
                } else {
                    quantityInput.val(quantity + quantityStep);
                }
            }

            form.submit();
        })

        $('input[type="radio"][name="packaging"]').on('change', function(e) {
            if (this.id === 'bag') {
                $('.form-product-cabas').submit();
            } else if (this.id === 'crate') {
                e.preventDefault();
                $('.cart-delete-bag').click();
            }
        })

        $('#SubmitCart').click(function(e) {
            e.preventDefault();
            const redirection = $(this).attr('href');
            const $commentForm = $('#commentForm');
            const comment = $commentForm.find('#comment').val();

            $.ajax({
                type: 'POST',
                url: $commentForm.attr('action'),
                data : { comment },
                success: (data) => {
                    console.log('oui !');
                    window.location.href = redirection;
                },
                error: function (e) {
                    console.log('Error.', e);
                }
            });
            window.location.href = redirection;
        })
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/cart.js